(() => {
  const EMAIL_TOKEN = 'c2VlZHNAYWxsaWFuY2VvZm5hdGl2ZXNlZWRrZWVwZXJzLmNvbQ==';
  const PHONE_DISPLAY = '(833) 760-7333';
  const PHONE_HREF = 'tel:+18337607333';

  function decodeEmail() {
    try {
      return window.atob(EMAIL_TOKEN);
    } catch (error) {
      return '';
    }
  }

  function repairFooterContact() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    const email = decodeEmail();
    const listItems = footer.querySelectorAll('.footer-block__text li');

    listItems.forEach((item) => {
      const text = item.textContent.replace(/\s+/g, ' ').trim();

      if (/^Email\s*:/i.test(text) && email) {
        item.textContent = 'Email: ';
        const link = document.createElement('a');
        link.className = 'bcm-footer-email-link';
        link.href = `mailto:${email}`;
        link.textContent = email;
        link.setAttribute('aria-label', `Email ${email}`);
        item.appendChild(link);
      }

      if (/^Phone\s*:/i.test(text)) {
        const existingLink = item.querySelector('a');
        if (existingLink) {
          existingLink.href = PHONE_HREF;
          existingLink.textContent = PHONE_DISPLAY;
          existingLink.removeAttribute('target');
          existingLink.removeAttribute('rel');
          existingLink.setAttribute('aria-label', `Call ${PHONE_DISPLAY}`);
        }
      }
    });
  }

  function initialize() {
    repairFooterContact();
    window.setTimeout(repairFooterContact, 250);
    window.setTimeout(repairFooterContact, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('load', repairFooterContact, { once: true });
})();
